<div class="class= mt-4 mb-2">
    <div><b i18n>Product Options</b></div>
    <table>
        <tr>
            <td *ngFor="let item of productOptions">
                <app-product-option-item [product]="item" [id]="productOptions[0].id"></app-product-option-item>
            </td>
        </tr>

    </table>
</div>

